// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 5.25V4.25C3 3.56 3.56 3 4.25 3H11.75C12.44 3 13 3.56 13 4.25V5.25',
  'M8 3V13M5.75 13H10.25',
];
